export const config = {
  // API_ADDRESS: "https://hy6ls4f9a1.execute-api.ap-southeast-2.amazonaws.com/dev/templates",
  API_ADDRESS:
    "https://sjmz3f1vp4.execute-api.ap-southeast-2.amazonaws.com/prod/templates",
  // TEMPLATES_API_ADDRESS: "https://app.w86dev.click/template/",
  TEMPLATES_API_ADDRESS: "https://app.workflow86.com/template/",
  // MAIN_API_ADDRESS: "https://app.w86dev.click/",
  MAIN_API_ADDRESS: "https://app.workflow86.com/",
  LANDING_PAGE_ADDRESS: "https://www.workflow86.com/",
};

export default config;
